import breakpoints from './breakpoints.configs';

const theme = { breakpoints };

export default theme;
